import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';

@Component({
    selector: 'app-producer-change-agency-modal',
    templateUrl: './producer-change-agency-modal.component.html',
    styleUrls: ['./producer-change-agency-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProducerChangeAgencyModalComponent implements OnInit {
  lob: string;
  showRegionFilter: boolean;
  currentPathDisablesChangeAgency: boolean = false;
  
  modalTitle: string;
  modalDesc: string;

  constructor(
    public dialogRef: MatDialogRef<ProducerChangeAgencyModalComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { 
      lob: LINE_OF_BUSINESS_ENUM,
      showRegionFilter: boolean,
      disableChangeOnPaths: string[],
      stayOnPage: boolean,
      modalTitle: string,
      modalDesc: string,
      enrollmentSubmitMode: boolean
    }
  ) { }

  ngOnInit(): void {
    this.modalTitle = this.data.modalTitle ? this.data.modalTitle : 'Change Agency';
    this.modalDesc = this.data.modalDesc;

    // TODO: move this to a form config.
    const disableChangeOnPaths = this.data.disableChangeOnPaths ? this.data.disableChangeOnPaths : [
      '/individual/new-business/off-exchange',
      '/individual/new-business/dental',
      '/individual/new-business/blue-edge-balance',
      '/medicare/enroll'
    ]

    this.currentPathDisablesChangeAgency = disableChangeOnPaths.some((path) => {
      return window.location.href.includes(path);
    });
  }

  agencyChange(newAgency) {
    this.dialogRef.close(newAgency);

    // if newAgency is null it means the user has canceled
    if (!newAgency) {
      return;
    }

    const alertDuration = 1000; // ms

    this.snackBar.open(`Saving information, will continue shortly.`, 'OK', {
      duration: alertDuration,
      panelClass: 'positive-panel-class'
    });

    if (!this.data.stayOnPage) {
      setTimeout(() => {
        window.location.reload();
      }, alertDuration)
    }
  }
}
